<template>
    <div class="d-flex main-container" :class="{ 'mt-2': type !== answerType.IMAGE_WITH_TEXT_SMALL }">
        <v-card
            class="d-flex flex-column align-center image-container"
            :class="{ selected: answerItem.selected }"
            @click="answerItem.selected ? onDeselected() : onSelected()"
            tile
            elevation="0"
        >
            <v-img
                :src="answerItem.imageUrl"
                :height="imageDimensions.height"
                :width="imageDimensions.width"
                :style="{ 'background-color': showFallback ? answerItem.color : '' }"
                @error="showFallback = true"
            >
                <template v-if="showFallback && !answerItem.color" #placeholder>
                    <v-icon color="grey" size="80%">{{ mdiHelp }}</v-icon>
                </template>
            </v-img>
            <div class="pa-1 text-container-small" v-if="type === answerType.IMAGE_WITH_TEXT_SMALL">
                <span class="text">{{ answerItem.displayName }}</span>
            </div>
        </v-card>
        <div class="overlay-text-container pa-1 px-2 primary" v-if="type !== answerType.IMAGE_WITH_TEXT_SMALL" :class="size">
            {{ answerItem.displayName }}
        </div>
    </div>
</template>

<script lang="ts">
import { Vue } from 'vue-property-decorator';
import { answerType } from '../definitions';
import { PropType } from 'vue';
import ShoppingGuideAnswer from './ShoppingGuideAnswer.vue';

export default Vue.extend({
    name: 'ShoppingGuideImage',
    mixins: [ShoppingGuideAnswer],
    props: {
        type: {
            type: String as PropType<answerType>,
            required: false,
            default: answerType.IMAGE_WITH_TEXT_BIG,
        },
    },
    data() {
        return {
            answerType,
        };
    },
    computed: {
        size() {
            switch (this.type) {
                case answerType.IMAGE_WITH_TEXT_SMALL:
                    return 'small';
                case answerType.IMAGE_WITH_TEXT_MEDIUM:
                    return 'medium';
                case answerType.IMAGE_WITH_TEXT_BIG:
                default:
                    return 'big';
            }
        },
        imageDimensions() {
            switch (this.type) {
                case answerType.IMAGE_WITH_TEXT_SMALL:
                    return { width: 130, height: 130 };
                case answerType.IMAGE_WITH_TEXT_MEDIUM:
                    return { width: 175, height: 175 };
                case answerType.IMAGE_WITH_TEXT_BIG:
                default:
                    return { width: 300, height: 200 };
            }
        },
    },
});
</script>

<style scoped lang="scss">
@import '../scss/answerStyles';

.main-container {
    position: relative;
    .image-container {
        border-width: 2px;
        border-style: solid;
        border-color: transparent;
        cursor: pointer;
    }
    .text-container-small {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        font-size: 14px;
        font-weight: 300;
    }
    .overlay-text-container {
        position: absolute;
        font-weight: 500;
        &.medium {
            left: 22px;
            top: -10px;
            font-size: 12px;
        }
        &.big {
            left: 30px;
            top: -13px;
            font-size: 14px;
        }
    }
}
</style>
